
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../../Services/api.service';
import { StorageService } from '../../../../../../Services/storage.service';
import { SweetAlert } from '../../../../../../Services/sweetalet.service';
import { CommonServices } from 'src/app/Services/common.service';


@Component({
  selector: 'app-add-shift',
  templateUrl: './add-shift.component.html',
  styleUrls: ['./add-shift.component.css']
})
export class AddShiftComponent implements OnInit {

  public branchInformation=[];      // all branch data

  public shiftForm: FormGroup;
  public fieldOptions=[{  branch:[], isEnable:[{ name:"Active",value:'1'},{ name:"Inactive",value:'0'}]}];         // dropdown option object
  public startTime: any;
  public endTime: any;
  public exportTime = { hour: 0, minute: 0, meriden: 'PM', format: 12 , val: 'startData'};

  public finalCheck:boolean = false;

  public formObject = {
      shiftName: '',
      branch: '',
      startTime: '',
      endTime: '',
      isEnable: ''
  }
  public showBranch:boolean = false;

  constructor(
    public api: ApiService,
    public storage: StorageService,
    private formBuilder: FormBuilder,
    public router: Router,
    public swal: SweetAlert,
    public com:CommonServices
    ) { }

  ngOnInit(): void {

    this.shiftFormLoad();         // initialize shift form
    this.getBranchList();         // get organization branch data

  }
 
  getBranchList() {
    this.showBranch = false;
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      console.log(res);
      if (res.status == 'success') {
        this.branchInformation = res.data;
        this.addBranchOptions();
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  
  addBranchOptions(){
    if(this.branchInformation && this.branchInformation.length>0){
      this.branchInformation.filter((e)=>{
        let option={name:e.branchName,value:e.branchID};
        this.fieldOptions[0].branch.push(option);
      });
    }
    this.showBranch = true;
  }

  shiftFormLoad() {
    this.shiftForm = this.formBuilder.group({
      shiftName: ['',Validators.required],
      branch: ['',Validators.required],
      startTime: ['',Validators.required],
      endTime: ['',Validators.required],
      isEnable: ['',Validators.required],
      isNodalShift_Login: [false],
      isNodalShift_Logout: [false]
    });
  }

  searchSelectResult(field,e){      
    this.shiftForm.controls[field].patchValue(e.value);
  }

  patchFieldValue(field){
    this.shiftForm.controls[field].patchValue(this.time24to12(this.formObject[field]));
  }

  time24to12(time){
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time.length > 1) {
      time = time.slice(1); 
      time[5] = +time[0] < 12 ? ' AM' : ' PM';
      time[0] = +time[0] % 12 || 12;
    }
    return time.join('');
  }

  /* checking error in fields*/
  public checkError = (controlName: string, errorName: string) => {
    const control = this.shiftForm.get(controlName);
    return control ? control.hasError(errorName) : false;
  }

  cancel(){
    this.router.navigate(['/organization/transport-manager/information/orgInfo/shift/list-shift']);
    this.shiftForm.reset();
  }

  convert12HrsTo24Hrs(getTime:any){
    let final24Hrs:any='';
    const [time, modifier] = getTime.split(" ");
        let [hours, minutes] = time.split(":");
        if (hours === "12") {
            hours = "00";
        }
        if (modifier === "PM") {
            hours = parseInt(hours, 10) + 12;
        }
        final24Hrs = `${hours}:${minutes}`
        return final24Hrs;
    }

  onSubmit() {
    this.finalCheck = true;
    if(this.shiftForm.valid){
      const obj = {
        orgID: this.storage.get('userInfo').orgID,
        ...this.shiftForm.value,       
      };
      obj['isEnable'] = Number(obj['isEnable']);
      obj['startTime'] = this.convert12HrsTo24Hrs(this.shiftForm.value.startTime);
      obj['endTime'] = this.convert12HrsTo24Hrs(this.shiftForm.value.endTime);
      
      this.api.CreateShift(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction('success', res.status, res.message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/shift/list-shift']);
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 2000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }

}
